/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * @emails react-core
 * @flow
 */

import React, {Component} from 'react';
import Flex from 'components/Flex';
import Footer from 'components/LayoutFooter';
import Header from 'components/LayoutHeader';
import {media} from 'theme';
import Search from "../search";


type Props = {
  children: Function,
  location: Location,
};

class Template extends Component<Props> {
  render() {
    const {children, location} = this.props;
    // TODO - is there a better way to check if we need we have a sidebar?
    let layoutHasSidebar = false;
    if (
      location.pathname.match(
        /^\/(docs|tutorial|community|blog|contributing|warnings)/,
      )
    ) {
      layoutHasSidebar = true;
    }

    return (
      <div
        css={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: 'calc(100vh - 40px)',
        }}>
        <Header location={location} />
        <Search/>
        <Flex
          direction="column"
          shrink="0"
          grow="1"
          valign="stretch"
          css={{
            flex: '1 0 auto',
            marginTop: 60,
            [media.between('medium', 'large')]: {
              marginTop: 50,
            },
            [media.lessThan('medium')]: {
              marginTop: 40,
            },
          }}>
          {children}
        </Flex>
        <Footer layoutHasSidebar={layoutHasSidebar} />
        <div>
          <a target="_blank" rel="noopener noreferrer" href="https://airtable.com/shrbFtpMDN7s2FVm5">
        <button css={{
          width: "auto",
          margin: "auto",
          "font-size": "15px",
          "font-weight": "bold",
          "border-radius": "50px",
          color: "#fff",
          padding: "9px 24px",
          background: "#e13c4c",
          opacity: "1",
          transition: "opacity .2s ease",
          border: "none",
          outline: "none",
          bottom: 10, // iOS Safari's inert "bottom 44px"
          position: 'fixed',
          right: 10,
          zIndex: 3,
          boxShadow: '0 0 20px rgba(0, 0, 0, 0.3)',
        }}>
        اقترح بوست للنشر
        </button>
        </a>
        </div>
      </div>
    );
  }
}

export default Template;
